import { render } from "./video.vue?vue&type=template&id=1b5de9d8&scoped=true&ts=true"
import script from "./video.vue?vue&type=script&lang=ts"
export * from "./video.vue?vue&type=script&lang=ts"

import "./video.vue?vue&type=style&index=0&id=1b5de9d8&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5de9d8"]])

export default __exports__